import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-menu-coach-info',
  templateUrl: './menu-coach-info.component.html',
  styleUrls: ['./menu-coach-info.component.scss']
})
export class MenuCoachInfoComponent {
  @Input() coachingHours = [];
// TODO: What is this component for? Is this tech debt?
}
